import { UserPlus } from '@sweep-io/sweep-design/dist/icons';
import { iconNameToIconComponent } from '../../pages/get-started/agenticPrompts';
import { Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

export const PromptLibraryIcon = ({ icon }: { icon?: string }) => {
  const IconComponent =
    icon && iconNameToIconComponent[icon] ? iconNameToIconComponent[icon] : UserPlus;

  return (
    <Stack>
      <IconComponent color={colors.grey[700]} />
    </Stack>
  );
};
